export const selectSearchByChildrenText = (input, option) =>
  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
